export default {
    en: {
        no: 'No',
        yes: 'Yes',
        next: 'Next',
        finish: 'Finish',
        prev: 'Back',
        login: 'Login',
        sing_in: 'Sign in',
        sing_up: 'Sign up',
        start_journey: 'New here?',
        authentication: 'Sign in to your account',
        register: 'Register',
        error: 'Oops, an error occured!',
        try_again: 'Try again',
        not_found: 'This page does not exists',
        go_main_page: 'Go to main page',
        connect_with: 'Connect with',
        change: 'Change',
        save_changes: 'Save changes',
        name: 'Name',
        first_name: 'First name',
        last_name: 'Last name',
        confirm_email: 'Confirm email',
        password: 'Password',
        phone: 'Phone',
        free: 'Free',
        continue: 'Continue',
        hello: 'Hello',
        select: 'Select',
        selected: 'Selected',
        please_select: 'Please select',
        back_to_homepage: 'Back to homepage',
        see_your_listings: 'See your listings',
        exit: 'Exit',
        sold_by: 'Sold by',
        tickets_sold: 'sold tickets',
        tickers_are_checked: 'Tickets are checked',
        antifraud_sistem: 'Our anti-fraud system analyses the tickets',
        secured_transactions: 'Secure transactions',
        secure_payments: '100% secure payments All data is transmitted securely',
        buyer_guarantee: '100% Buyer Guarantee',
        get_the_ordered_tickets: 'We guarantee you’ll get the tickets you ordered just on time.',
        all_rights_reserved: 'All rights reserved',
        faq: 'FAQ',
        purchase_policy: 'Purchase Policy',
        privacy_policy: 'Privacy Policy',
        cookie_policy: 'Cookie Policy',
        terms: 'Terms & Conditions',
        manange_cookies: 'Manage my cookies and ad choices',
        error_title: 'Whoops, page not found!',
        error_description: 'The page or event you are looking for was not found.',
        reset_password_title: 'Reset Password',
        reset_password_subtitle: 'Need a new password? Let\'s get you a new one. Enter your email below to continue.',
        cookiebar_message: 'This site uses cookies. By continuing to browse, you accept their use.',
        cookiebar_allow: 'I agree',
        cookiebar_details: 'Show more details',
    },
    ro: {
        no: 'Nu',
        yes: 'Da',
        next: 'Înainte',
        finish: 'Finalizează',
        prev: 'Înapoi',
        login: 'Intră în cont',
        sing_in: 'Conectează-te',
        sing_up: 'Înregistrează-te',
        start_journey: 'Ești nou aici?',
        authentication: 'Conectează-te în contul tău',
        register: 'Înregistrare',
        error: 'Ups, a apărut o eroare!',
        try_again: 'Încearcă din nou',
        not_found: 'Această pagină nu există',
        go_main_page: 'Mergi la pagina principală',
        connect_with: 'Conectează-te cu',
        change: 'Schimbă',
        save_changes: 'Salvează modificările',
        name: 'Nume',
        first_name: 'Prenume',
        last_name: 'Nume',
        phone: 'Telefon',
        confirm_email: 'Confirmă emailul',
        password: 'Parolă',
        free: 'Gratuit',
        continue: 'Continuă',
        hello: 'Salut',
        select: 'Selectează',
        selected: 'Selectat',
        please_select: 'Te rugăm să selectezi',
        back_to_homepage: 'Înapoi la pagina principală',
        see_your_listings: 'Vezi listările tale',
        exit: 'Ieșire',
        sold_by: 'Vandut de',
        tickets_sold: 'bilete vandute',
        tickers_are_checked: 'Biletele sunt verificate',
        antifraud_sistem: 'Sistemul nostru antifraudă analizează biletele',
        secured_transactions: 'Tranzacții securizate',
        secure_payments: 'Plăți 100% securizate Toate datele sunt transmise în siguranță',
        buyer_guarantee: 'Garanția Cumpărătorului 100%',
        get_the_ordered_tickets: 'Îți garantăm că vei primi biletele comandate la timp.',
        all_rights_reserved: 'Toate drepturile rezervate',
        faq: 'Întrebari frecvente',
        purchase_policy: 'Politica de achiziție',
        privacy_policy: 'Politica de confidențialitate',
        cookie_policy: 'Politica de cookie',
        terms: 'Termeni și condiții',
        manange_cookies: 'Gestionează cookie-urile și opțiunile de publicitate',
        error_title: 'Whoops, pagina nu a fost găsită!',
        error_description: 'Pagina sau evenimentul pe care îl căutați nu a fost găsit.',
        reset_password_title: 'Resetează parola',
        reset_password_subtitle: 'Aveți nevoie de o nouă parolă? Hai să-ți faci una nouă. Introduceți adresa de e-mail mai jos pentru a continua.',
        cookiebar_message: 'Acest site folose\u0219te cookie-uri. Continuarea navig\u0103rii implic\u0103 acceptarea lor.',
        cookiebar_allow: 'Sunt de acord',
        cookiebar_details: 'Mai multe detalii',
    },
};
